module.exports = __webpack_public_path__ + "static/img/yaoqinghan.dcf8dd2b.jpg";